// PR 53 fixes · fork S: F4 — the aging only SUGGESTS leaving a retention payable out; the account needs classification until the
// auditor ticks it with a reason. EN + AR, merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34P53S = {
  en: {
    p53s: {
      appearsToExclude: "Aging appears to exclude {code} - {amount}",
      notListed: "The aging listing does not include {code} - {amount}",
      howTo: "Untick Trade to leave it out, or keep it as trade. A reason is required either way.",
      keepTrade: "Keep as trade",
      reasonPh: "Reason for the classification",
      reasonMissing: "Give the reason for this classification.",
      diffBaseline: "Difference when first checked: {v}",
    },
  },
  ar: {
    p53s: {
      appearsToExclude: "يبدو أن تقرير الأعمار يستبعد {code} - {amount}",
      notListed: "قائمة تقرير الأعمار لا تتضمن {code} - {amount}",
      howTo: "ألغِ خانة \"تجاري\" لاستبعاده، أو أبقِه تجاريًا. السبب مطلوب في الحالتين.",
      keepTrade: "إبقاؤه تجاريًا",
      reasonPh: "سبب التصنيف",
      reasonMissing: "أدخل سبب هذا التصنيف.",
      diffBaseline: "الفرق عند أول مراجعة: {v}",
    },
  },
};

export default I18N_B34P53S;
